import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { Divider, IconButton, Typography } from "@mui/material";
import { CloseIcon, tableEditWhiteIcon } from "../../../assets/images";
import LeadViewDetailsModal from "../../LeadModule/LeadViewDetailsModal/LeadViewDetailsModal";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import DrawerLoader from "../DrawerLoader/DrawerLoader";

type Anchor = "top" | "left" | "bottom" | "right";

interface CustomDrawerProps {
  isRight: boolean;
  isOpen: boolean;
  onClose: () => void;
  history: any;
  clientCode: number | null;
  singleClientleadDirectoryDetails: any;
  multiSelectData: any;
  sortByLeadReceivedOn: any;
  sortByStage: any;
  sortByComment: any;
  searchData: string;
  loginData: LoginResponseType;
  fetching: boolean;
  activeTab?:string | undefined;
}

const RightDrawer: React.FC<CustomDrawerProps> = ({
  isRight,
  isOpen,
  onClose,
  history,
  clientCode,
  singleClientleadDirectoryDetails,
  multiSelectData,
  sortByLeadReceivedOn,
  sortByStage,
  sortByComment,
  searchData,
  loginData,
  fetching,
  activeTab
}) => {
  const LocalDrawerContent = (
    <Box
      sx={{
        width: 800,
        padding: 2,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "17px" }}>
          <IconButton onClick={onClose}>
            <img src={CloseIcon} alt="Close Icon" />
          </IconButton>

          <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: "500" }}>
            Lead Details
          </Typography>
        </div>

        <button
          style={{
            backgroundColor: "#dd4433",
            border: "none",
            padding: "10px 14px",
            color: "white",
            fontSize: "14px",
            borderRadius: "5px",
            fontWeight: "600",
            marginRight: "25px",
          }}
          onClick={() => {
            onClose();
            history?.push({
              pathname: `/lead-module/lead-directory-list/edit/${clientCode}`,
              state: {
                clientCode,
                multiSelectData,
                sortByLeadReceivedOn,
                sortByStage,
                sortByComment,
                searchData,
                isPersist: true,
                tab:activeTab
              },
            });
          }}
        >
          <img src={tableEditWhiteIcon} style={{ paddingRight: "7px" }} />
          Edit Lead
        </button>
      </Box>
      <hr style={{ margin: "2px 0px" }} />
      {fetching && <DrawerLoader />}
      <LeadViewDetailsModal
        singleClientleadDirectoryDetails={singleClientleadDirectoryDetails}
        loginData={loginData}
      />
      <div></div>
    </Box>
  );
  return (
    <div>
      {isRight && (
        <React.Fragment>
          <Drawer anchor="right" open={isOpen} onClose={onClose}>
            {LocalDrawerContent}
          </Drawer>
        </React.Fragment>
      )}
    </div>
  );
};

export default RightDrawer;
